import { NgModule } from "@angular/core";
import { S25CustomAttributeValueComponent } from "./s25.custom.attribute.value.component";
import { S25CustomAttributeOptionsComponent } from "./s25.custom.attribute.options.component";

@NgModule({
    imports: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
    exports: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
    declarations: [],
    providers: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
})
export class S25CustomAttributeModule {}
